import { useState } from "react";
import Chart from "react-apexcharts";
import { ChartCard } from "../../../componentes/chart/CardChart";
import TabelaEntriesGrafico from "./TabelaEntriesGrafico";
import { donutOptions, barOptions, CORES_GRAFICO } from "../../../utils/solicitacoes/chartOptions";
import { STATUS_CONFIG } from "../../../utils/solicitacoes/statusConfig";

/**
 * Os 3 gráficos padrão (por status, por etapa, evolução no período) + 1 gráfico específico do
 * processo (`porExtra`/`labelExtra`), consumindo o `DashboardBasicoDTO` compartilhado pelo
 * backend. Usado pelos processos "simples" (sem valores monetários/colunas ricas próprias).
 */
export default function GraficosBasicos({ dashboard }) {
    const porStatusEntries = Object.entries(dashboard?.porStatus || {}).map(([k, v]) => [STATUS_CONFIG[k]?.label || k, v]);
    const porEtapaEntries = Object.entries(dashboard?.porEtapa || {});
    const porExtraEntries = Object.entries(dashboard?.porExtra || {});
    const evolucaoEntries = Object.entries(dashboard?.evolucaoPeriodo || {});

    const [viewStatus, setViewStatus] = useState("chart");
    const [viewEtapa, setViewEtapa] = useState("chart");
    const [viewExtra, setViewExtra] = useState("chart");
    const [viewEvolucao, setViewEvolucao] = useState("chart");

    return (
        <>
            <div className="lg:col-span-4">
                <ChartCard title="Por status" view={viewStatus} onViewChange={setViewStatus} accent={CORES_GRAFICO[0]}
                    tableContent={<TabelaEntriesGrafico entries={porStatusEntries} colunaValor="Quantidade" />}>
                    {porStatusEntries.length === 0 ? (
                        <p className="text-sm text-muted-foreground flex items-center justify-center h-64">Sem dados para o filtro atual.</p>
                    ) : (
                        <Chart type="donut" height="100%" series={porStatusEntries.map(([, v]) => v)}
                            options={donutOptions(porStatusEntries.map(([k]) => k))} />
                    )}
                </ChartCard>
            </div>
            <div className="lg:col-span-4">
                <ChartCard title="Por etapa" view={viewEtapa} onViewChange={setViewEtapa} accent={CORES_GRAFICO[1]}
                    tableContent={<TabelaEntriesGrafico entries={porEtapaEntries} colunaValor="Quantidade" />}>
                    {porEtapaEntries.length === 0 ? (
                        <p className="text-sm text-muted-foreground flex items-center justify-center h-64">Sem dados para o filtro atual.</p>
                    ) : (
                        <Chart type="donut" height="100%" series={porEtapaEntries.map(([, v]) => v)}
                            options={donutOptions(porEtapaEntries.map(([k]) => k))} />
                    )}
                </ChartCard>
            </div>
            <div className="lg:col-span-4">
                <ChartCard title={dashboard?.labelExtra || "Detalhamento"} view={viewExtra} onViewChange={setViewExtra} accent={CORES_GRAFICO[2]}
                    tableContent={<TabelaEntriesGrafico entries={porExtraEntries} colunaValor="Quantidade" />}>
                    {porExtraEntries.length === 0 ? (
                        <p className="text-sm text-muted-foreground flex items-center justify-center h-64">Sem dados para o filtro atual.</p>
                    ) : (
                        <Chart type="donut" height="100%" series={porExtraEntries.map(([, v]) => v)}
                            options={donutOptions(porExtraEntries.map(([k]) => k))} />
                    )}
                </ChartCard>
            </div>
            <div className="lg:col-span-12">
                <ChartCard title="Evolução no período" view={viewEvolucao} onViewChange={setViewEvolucao} accent={CORES_GRAFICO[3]}
                    tableContent={<TabelaEntriesGrafico entries={evolucaoEntries} colunaValor="Quantidade" />}>
                    {evolucaoEntries.length === 0 ? (
                        <p className="text-sm text-muted-foreground flex items-center justify-center h-64">Sem dados para o filtro atual.</p>
                    ) : (
                        <Chart type="bar" height="100%" series={[{ name: "Solicitações", data: evolucaoEntries.map(([, v]) => v) }]}
                            options={barOptions(evolucaoEntries.map(([k]) => k))} />
                    )}
                </ChartCard>
            </div>
        </>
    );
}
